import React from 'react';
import { PageHeader } from '../../../shared/components/patterns';

export default function StaffHeader() {
  return (
    <PageHeader
      title="Team"
      description="Team aziendale e comunicazioni dirette"
    />
  );
}
